// extracted by mini-css-extract-plugin
export var externalLink = "_ga-0";
export var internalLinkLabel = "_ga-1";